// Alert «non trasmessa allo SdI entro 12 giorni» (art. 21 c.4 DPR 633/72).
// Il livello lo decide il backend (`sdi_deadline`): qui si disegna soltanto.
//
// 🔑 Il badge dice due cose diverse a seconda della sigla, e la differenza è
// il punto: sulle FA la mancata trasmissione è PROVATA (esiste un documento
// FAD con lo stesso numero), su OSS/RC/RCO quel segnale non esiste e quindi si
// può solo dire «non risulta». Nasconderlo vorrebbe dire costruire fiducia su
// un dato che non la regge — è così che una OSS è rimasta ferma 49 giorni.
import type { Proposal } from "../types";

/** Sfondo riga: rosso/ambra scavalcano la zebra, altrimenti zebra normale. */
export function rowToneSdi(proposal: Proposal): string {
  if (proposal.sdi_alert === "rosso") return "bg-red-soft hover:bg-red-soft/70";
  if (proposal.sdi_alert === "giallo") return "bg-amber-soft hover:bg-amber-soft/70";
  return "odd:bg-card even:bg-paper-2/50 hover:bg-accent-soft/60";
}

export function SdiAlertBadge({ proposal }: { proposal: Proposal }) {
  const livello = proposal.sdi_alert ?? null;
  if (!livello) return null;
  const giorni = proposal.sdi_giorni;
  const provato = proposal.sdi_verificabile === true;
  const testa = provato
    ? "Non trasmessa allo SdI: verificato in Eureka (nessun documento FAD con questo numero)."
    : "Non RISULTA trasmessa allo SdI. Su OSS/RC/RCO Eureka non espone un segnale di " +
      "trasmissione: questo è lo stato dichiarato nel portale, non un riscontro.";
  const coda =
    livello === "rosso"
      ? " Termine di 12 giorni SUPERATO (art. 21 c.4 DPR 633/72): ridatarla ora richiede anche " +
        "un numero nuovo in coda alla serie, altrimenti numero e data si invertono."
      : " Mancano meno di 2 giorni al termine: finché è l'ultima della sua serie basta " +
        "ridatarla, senza rinumerare.";
  return (
    <span
      className={`ml-1 inline-flex shrink-0 items-center rounded px-1 py-px text-[10.5px] font-semibold text-ink ${
        livello === "rosso" ? "bg-red-soft" : "bg-amber-soft"
      }`}
      title={`${testa}${coda}`}
    >
      ⚠ {giorni != null ? `${giorni}gg` : "SdI"} · {provato ? "verificato" : "dichiarato"}
    </span>
  );
}
